import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import LeftRightSplit from '../ui/LeftRightSplit';
import TextBoxUncontrolled from '../ui/TextBoxUncontrolled';
import SecondaryButton from '../ui/SecondaryButton';

function ClearableSearch({ initialValue, onSearch }:{initialValue: string, onSearch: (x:string|null) => void}) {
  const textRef = useRef<HTMLInputElement>(null);
  const [search, setSearch] = useState(false);
  const searchButton = search ? 'Clear Search' : 'Search'
  function handleSearch() {
    if (textRef && textRef.current) {
      if(textRef.current.value !== ''){
        onSearch(textRef.current.value);
        setSearch(true);
      }
    }
  }

  function clearSearch() {
    if (textRef && textRef.current) {
      textRef.current.value = '';
      onSearch(null);
      setSearch(false);
    }
  }

  return (
    <LeftRightSplit
      leftSize="calc(100% - 80px)"
      rightSize="80px"
      left={
        <div style={{position: 'relative'}}>
          <TextBoxUncontrolled
            name='clerable-search-text'
            ref={textRef}
            placeholder="Search"
            initialValue={initialValue}
            onEnter={handleSearch}
            style={{
              display: 'block',
              float: 'left',
              width: '100%',
              paddingRight: '35px',
              height: '18px',
            }}
          />
          <FontAwesomeIcon color='#a1a1a1' icon={faSearch} onClick={handleSearch} style={{cursor: 'pointer', position: 'absolute', right: '5px', top: '3px'}} />
        </div>
      }
      right={
        <div style={{marginLeft: '5px'}}>
          <SecondaryButton  name='clerable-search-button' size="extrasmall" onClick={()=>{
            if(search) clearSearch();
            else handleSearch();
          }}>
           {searchButton}
          </SecondaryButton>
        </div>
      }
    />
  );
}

ClearableSearch.defaultProps = {
  onSearch: () => {},
};

ClearableSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  initialValue: PropTypes.string,
};

export default React.memo(ClearableSearch);
